import React, { Suspense } from "react";
import ThemeProvider from "./theme";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Routes from "./routes/Routes";
import { styled } from "@mui/material";
import { SnackbarProvider } from "notistack";
import Loader from "./components/Loader";
import ScrollToTop from "./components/ScrollToTop";
import "./style/App.css";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./store/store";

// alert notification
const StyledSnackbarProvider = styled(SnackbarProvider)`
  fontfamily: "DM Sans !important", &.notistack-MuiContent-success {
    background-color: #0caf60;
    color: #ffffff;
    fontfamily: "DM Sans";
  }
  ,
  &.notistack-MuiContent-error {
    background-color: #ff1e1e;
    fontfamily: "DM Sans";
  }

  ,
  &.notistack-MuiContent {
    box-shadow: 0px 3px 2px -2px rgba(0, 0, 0, 0.06),
      0px 5px 3px -2px rgba(0, 0, 0, 0.02);
    font-weight: 500;
    border-radius: 12px;
    fontfamily: "DM Sans";
  }
`;

const App = () => {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <BrowserRouter>
          <HelmetProvider>
            <ThemeProvider>
              <ScrollToTop />
              <StyledSnackbarProvider
                hideIconVariant
                autoHideDuration={2000}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
              >
                <Suspense fallback={<Loader />}>
                  <Header />
                  <Routes />
                  <Footer />
                </Suspense>
              </StyledSnackbarProvider>
            </ThemeProvider>
          </HelmetProvider>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  );
};

export default App;
